import Swiper from "swiper";

const productPageSlider = document.querySelector(".js-product-page-slider-init");

if (productPageSlider) {
    window.addEventListener("load", () => initProductPageSlider(productPageSlider));
}

function initProductPageSlider(productPageSlider) {
    const sliderContainer = productPageSlider.querySelector(".js-product-page-swiper-container");
    const sliderThumbs = productPageSlider.querySelector(".js-product-page-slider-thumbs-init");

    if (sliderContainer && sliderThumbs) {
        const slides = productPageSlider.querySelectorAll(".swiper-slide");

        if (slides.length > 1) {
            const pageSliderThumbs = new Swiper(".js-product-page-slider-thumbs-container", {
                spaceBetween: 6,
                slidesPerView: 6,
                watchSlidesVisibility: true,
                watchSlidesProgress: true,
                observer: true,
                watchOverflow: true,
                navigation: {
                    nextEl: ".js-product-page-slider-thumbs-init .swiper-button-next",
                    prevEl: ".js-product-page-slider-thumbs-init .swiper-button-prev",
                },
                on: {
                    init: () => {
                        const thumbs = sliderThumbs.querySelectorAll(".swiper-slide");

                        thumbs[0].classList.add("active");
                    },
                },
            });

            const productPageSliderPaginationOptions = () => {
                let options = false;

                if (window.mobileMedia) {
                    options = {
                        el: ".js-product-page-slider-controls .swiper-pagination",
                        clickable: true,
                    };
                }

                return options;
            };

            const productPageSliderNavigationOptions = () => {
                let options = false;

                if (!window.mobileMedia) {
                    options = {
                        nextEl: ".js-product-page-slider-controls .swiper-button-next",
                        prevEl: ".js-product-page-slider-controls .swiper-button-prev",
                    };
                }

                return options;
            };

            new Swiper(sliderContainer, {
                spaceBetween: 10,
                watchOverflow: true,

                pagination: productPageSliderPaginationOptions(),
                navigation: productPageSliderNavigationOptions(),

                thumbs: {
                    swiper: pageSliderThumbs,
                    slideThumbActiveClass: "active",
                },
            });
        }
    }
}
